import gql from 'graphql-tag';

const CREATE_POLL = gql`
    mutation createPoll($input: PollInput) {
        createPoll (input: $input) {
            internalCode
        }
    }
`;

export default CREATE_POLL;
